<div class="modal-item-modal">
    <div class="modal-title">
        <div class="close" (click)="dialog.close()">
            <img src="/images/icons/close.svg" alt="Close" width="30px" />
        </div>
    </div>
    <div class="modal-content">
        <section class="section section-foto">
            <div class="foto">
                <figure *ngIf="data.foto != null">
                    <img [src]="data.foto" alt="data.nome" width="100%" />
                </figure>
                <figure *ngIf="data.foto == null">
                    <img src="/images/foto/foto.svg" alt="data.nome" width="100%" />
                </figure>
            </div>
            <div class="section-content">
                <h3>{{data.empresa_nome}}</h3>
                <div class="info">
                    <div class="item">
                        <strong>Proprietário (a): </strong>
                        <span>{{data.nome}}</span>
                    </div>
                    <div class="item" *ngIf="data.link_site != '' && data.link_site != null">
                        <strong>Nosso site: </strong>
                        <a [href]="data.link_site" target="_blank">{{data.link_site}}</a>
                    </div>
                </div>
                <div class="redes-sociais">
                    <div class="item" *ngIf="data.link_facebook != null && data.link_facebook != ''">
                        <a [href]="data.link_facebook" title="Facebook" target="_blank">
                            <img src="/images/icons/facebook-01.svg" alt="Facebook" width="30px" />
                        </a>
                    </div>
                    <div class="item" *ngIf="data.link_instagram != '' && data.link_instagram != null">
                        <a [href]="data.link_instagram" title="Instagram" target="_blank">
                            <img src="/images/icons/instagram-01.svg" alt="Instagram" width="30px" />
                        </a>
                    </div>
                    <div class="item">
                        <a href="#" title="Whatsapp" (click)="openWhats()">
                            <img src="/images/icons/whatsapp-02.svg" alt="WhatsApp" width="30px" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <div class="linha"></div>
        <section class="section section-about">
            <h3>Sobre a Empresa</h3>
            <article [innerHtml]="data.texto"></article>
        </section>
        <div class="linha"></div>
        <section class="section section-services">
            <h3>Meus Serviços</h3>
            <article [innerHtml]="data.empresa_servicos"></article>
        </section>
        <div class="linha" *ngIf="data.empresa_endereco_ativo"></div>
        <section class="section section-address" *ngIf="data.empresa_endereco_ativo">
            <h3>
                Endereço
            </h3>
            <article [innerHtml]="data.empresa_endereco"></article>
            <div class="content-map" [innerHtml]="data.empresa_endereco_mapa | safeHtml"></div>
        </section>
    </div>
</div>
